<template>
  <v-app>
    <core-filter />

    <core-toolbar />

    <core-drawer />

    <core-view />
  </v-app>
</template>
<script>
import { mapActions } from "vuex";
export default {
  created() {
    this.tryAutoLogin();
    this.setInitialsConfig();
    const url_path = window.location.hostname;
    const partner = url_path.split(".")[0] || "enercred";
    localStorage.setItem("partner", partner);
  },
  mounted() {
    document.addEventListener("click", this.resetInactivityTimer);
  },
  methods: {
    ...mapActions(["tryAutoLogin", "setInitialsConfig"]),
    resetInactivityTimer() {
      //Configura o logout para daqui 2 horas
      const now = new Date();
      localStorage.setItem("expirationDate", new Date(now.getTime() + 7200000));
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/index.scss";
/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}

.swal2-title {
  font-size: 1rem !important;
  font-family: Georgia, serif;
}
</style>
